import { Mutation } from 'vuex'
import { FixedState } from '../types'

const setActiveSectionId: Mutation<FixedState> = (state, id: number) => {
  state.activeSectionId = id
}

export default setActiveSectionId
